<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog title="详情" :visible.sync="show" width="30%">
			<div class="flex">
				<div class="box">
					<div><span>商铺号 ：</span><span>{{ obj.shopNum }}</span></div>
					<div><span>商铺名称 ：</span><span>{{ obj.shopName }}</span></div>
					<div><span>申请人 ：</span><span>{{ obj.applyName }}</span></div>
					<div><span>联系方式 ：</span><span>{{ obj.phone }}</span></div>
					<div><span>装修开始时间 ：</span><span>{{ obj.startTime ? obj.startTime.split("T")[0] : "" }}</span></div>
					<div><span>装修结束时间 ：</span><span>{{ obj.endTime ? obj.endTime.split("T")[0] : "" }}</span></div>
					<div><span>每天装修时间段 ：</span><span>{{ obj.timeSlot }}</span></div>
					<div><span>工期 ：</span><span>{{ obj.constructionPeriod }}天</span></div>
					<div><span>装修描述 ：</span><span>{{ obj.describes }}</span></div>
					<div><span>装修图 ：<span @click="downFil"
								style="color: #3C98FF;cursor: pointer;">{{ obj.fileRes.name }}</span></span></div>
				</div>
				<el-timeline>
					<el-timeline-item>
						{{ obj.applyName }}
					</el-timeline-item>
					<el-timeline-item>
						商管{{ obj.businessManagement }}
					</el-timeline-item>
					<el-timeline-item>
						物业{{ obj.propertyManagement }}
					</el-timeline-item>
					<el-timeline-item>
						{{ obj.result }}
					</el-timeline-item>
				</el-timeline>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<el-input v-model="form.shopNum" placeholder="商铺号" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="商铺名称">
						<el-input v-model="form.shopName" placeholder="商铺名称" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="装修开始时间">
						<el-date-picker v-model="form.startTime" type="date" placeholder="装修开始时间" style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="申请人">
						<el-select v-model="form.applyId" placeholder="申请人" style="width: 120px;">
							<el-option v-for="item in users" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="form.phone" placeholder="手机号" style="width: 120px;"></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="form.result" placeholder="状态" style="width: 100px;">
							<el-option label="审核中" value="审核中"></el-option>
							<el-option label="已拒绝" value="已拒绝"></el-option>
							<el-option label="已同意" value="已同意"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="getAll">查询</el-button>
						<el-button type="primary" @click="cz">重置</el-button>
						<el-button type="primary" @click="dc">导出</el-button>

					</el-form-item>
				</div>
				<div>
				</div>
			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>

			<el-table-column prop="shopNum" label="商铺号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>
			<el-table-column prop="describes" label="装修描述"></el-table-column>
			<el-table-column prop="startTime" label="装修开始时间">
				<template slot-scope="{row}">{{ setTime(row.startTime) }}</template>
			</el-table-column>
			<el-table-column prop="constructionPeriod" label="工期">
				<template slot-scope="{row}">{{ row.constructionPeriod }}天</template>
			</el-table-column>
			<el-table-column prop="applyName" label="申请人"></el-table-column>
			<el-table-column prop="phone" label="联系方式">
				<template slot-scope="{row}">{{ row.phone ? row.phone : "无" }}</template>
			</el-table-column>
			<el-table-column prop="result" label="状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="lookRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
		</el-pagination>
	</div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
import downloadFile from '../../assets/js/downloadFile.js';
export default {
	data() {
		return {
			count: 0,
			users: [], //申请人
			show: false,
			form: {
				applyId: "", //申请人id
				"phone": "", //联系电话
				"result": "", //审核结果  状态
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"startTime": "", //装修开始时间
				currentPage: 1,
				pageSize: 10,
			},
			addForm: {},
			data: [],
			obj: {
				fileRes: ""
			}, //详情数据
		}
	},
	methods: {
		cz() {
			this.form = {
				applyId: "", //申请人id
				"phone": "", //联系电话
				"result": "", //审核结果  状态
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"startTime": "", //装修开始时间
				currentPage: 1,
				pageSize: 10,
			}
			this.getAll()
		},
		downFil() {
			downloadFile(this.obj.fileRes)
		},
		lookRow(obj) {
			this.$http.get(`/api/bdShopRenovation/getShopRenovation?id=${obj.id}`).then(res => {
				this.obj = res.data.data
				this.show = true;
			})
		},
		handleCurrentChange(val) {
			this.form.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.form.pageSize = val;
			this.getAll()
		},
		dc() {
			publicExport("/api/bdShopRenovation/exportShopRenovation", this.form, "商铺装修申请")
		},
		getUsers() { //查询申请人
			this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
				console.log(res)
				this.users = res.data.data
			})
		},
		getAll() { //获取表格数据
			let startTime = "";
			if (this.form.startTime != "") {
				this.form.startTime = new Date(this.form.startTime).getTime()
			}
			if (this.form.startTime == 0) {
				this.form.startTime = null
			}
			this.$http.post("/api/bdShopRenovation/queryShopRenovation", {
				...this.form
			}).then(res => {
				console.log(res)
				this.count = res.data.data.totalNum;
				this.data = res.data.data.items
			})
		}
	},
	created() {
		this.getAll();
		this.getUsers();
	}
}
</script>

<style scoped="scoped">
.box {
	font-size: 16px;
	width: 70%;
}

.box>div {
	margin-bottom: 10px;
}
</style>
